export const createMenuSectionMutation = /* GraphQL */ `mutation CreateMenuSection($input: inputCreateMenuSection!) {
	createMenuSection(input: $input){
		id
		title
	}
}`
